module.exports = __webpack_public_path__ + "static/img/3.e666b28.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/3/eng/3.png
// module id = LI2c
// module chunks = 0